<template>

    <section>
      <div class="hero-body ">
        <div class="container">
          <h1 class="title is-2 is-spaced">
            {{content.title}}
          </h1>
          <p class="subtitle is-5">
            {{content.text}}
          </p>
          <div class="notification" style="max-width:700px; margin:0px auto;" >
            {{content.text2}}
          </div>

        </div>
      </div>
    </section>

</template>

<script>
  export default {
    name: 'Location',
    props: ['content']

  }
</script>

<style scoped>
</style>